import { render, staticRenderFns } from "./courseCatalogue.vue?vue&type=template&id=0075b45d&scoped=true&"
import script from "./courseCatalogue.vue?vue&type=script&lang=js&"
export * from "./courseCatalogue.vue?vue&type=script&lang=js&"
import style0 from "./courseCatalogue.vue?vue&type=style&index=0&id=0075b45d&prod&scoped=true&lang=css&"
import style1 from "./courseCatalogue.vue?vue&type=style&index=1&id=0075b45d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0075b45d",
  null
  
)

export default component.exports